import * as Yup from 'yup';
import React, { useState } from 'react';
import PhoneNumber from '../../../../../components/common/PhoneNumber';
// import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { makeStyles } from '@material-ui/core';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import http from '../../../../../config/http';
import { SUBSCRIPTION_REQUEST_QUOTE } from '../../../../../config/api';
import { setUserInfoToRedux } from '../../../../../components/auth/action';

const useStyles = makeStyles({
  phoneNumberClass: {
    padding: '0px!important',
    fontSize: '16px!important',
    fontFamily: 'Inter !important',
    fontWeight: '400',
    marginTop: '0px!important',
    transition: '.3s',
    borderRadius: '8px!important',
  },
  textField: {
    padding: '0px!important',
    fontSize: '16px!important',
    fontFamily: 'Inter !important',
    fontWeight: '400',
    marginTop: '8px!important',
    transition: '.3s',
    borderRadius: '8px!important',
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
      lineHeight: '1em',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      // border: '1px solid #5433FF',
    },
    '& .MuiFormHelperText-root': {
      letterSpacing: '0 !important',
      fontFamily: 'Inter',
      margin: '6px 0 0 0 !important',
      fontWeight: '500',
    },
    '& .MuiInputBase-inputMultiline': {
      padding: '0!important',
    },
    '& .MuiOutlinedInput-root .MuiInputBase-input': {
      borderRadius: '8px',
      background: '#fff',
      fontSize: '14px !important',
      // border: '1px solid #D0D5DD',
      boxShadow: ' 0px 1px 2px rgb(16 24 40 / 5%)',
      //   padding: '13.5px 14px',
      transition: '.3s',
      padding: '12px',
      fontFamily: 'Inter',
      '&:focus': {
        transition: '.3s',
        outline: '0',
        // boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%)',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
    },
  },
});

const buttonStyles = {
  borderRadius: '10px',
  boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  width: '100%',
  padding: '10px 14px',
  color: '#fff',
  transition: '0.2s',
  marginTop: '5px',
  fontWeight: '500',
  backgroundColor: '#5433ff',
  fontFamily: 'Inter',
  letterSpacing: '0',
  textTransform: 'inherit',
  '&:hover': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:focus': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:visited': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
};

function CustomPlanForm({ quoteSubmitted, btnText = 'Get My Quote', userPrompt = 'What do you want to achieve' }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { email, countryCode, mobile: mobileNumber } = useSelector(({ auth }) => auth?.user);
  const [isValidMobile, setIsValidMobile] = useState(false);
  const [mobile, setMobile] = useState({ number: mobileNumber ?? null, dialCode: countryCode ?? '+91' });
  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    message: Yup.string().max(2000),
  });

  const formik = useFormik({
    initialValues: {
      email: email,
      message: '',
    },
    validationSchema: LoginSchema,
    onSubmit: async (e, { setSubmitting }) => {
      const payload = {
        mobile: mobile?.number,
        countryCode: mobile?.dialCode,
        email: values.email,
        message: values.message,
      };
      try {
        await http.post(SUBSCRIPTION_REQUEST_QUOTE, payload);
        await setUserInfoToRedux(dispatch);
        toast.success('Quote requested successfully');
        quoteSubmitted(true);
        resetForm();
      } catch (err) {
        toast.error(err.response.data.message);
      }
      setSubmitting(false);
    },
  });

  const { errors, touched, values, handleSubmit, getFieldProps, resetForm } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3} style={{ textAlign: 'left' }}>
          <div className="customLabel">Email *</div>
          <TextField
            autoFocus
            fullWidth
            type="email"
            placeholder="abc@email.com"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
            InputLabelProps={{ shrink: false }}
            className={classes.textField}
          />
          <div className="customLabel mgTop">Phone number *</div>
          <div className={classes.phoneNumberClass}>
            <PhoneNumber
              countryCode={countryCode}
              mobileNumber={mobileNumber}
              handleDialCode={(val) => setMobile({ ...mobile, dialCode: val })}
              handlePhoneNumber={(number, isValid) => {
                setMobile({ ...mobile, number: number });
                setIsValidMobile(isValid);
              }}
            />
          </div>
          <div className="customLabel mgTop">{userPrompt} *</div>
          <TextField
            autoFocus
            fullWidth
            type="text"
            rows={4}
            multiline
            placeholder={
              userPrompt !== 'What do you want to achieve'
                ? 'Type here...'
                : 'eg: Increase sales, Reduce ACOS, Reduce Adspend......'
            }
            {...getFieldProps('message')}
            error={Boolean(touched.message && errors.message)}
            helperText={touched.message && errors.message}
            InputLabelProps={{ shrink: false }}
            className={classes.textField}
            style={{ padding: '0 !important' }}
          />
          <LoadingButton
            sx={buttonStyles}
            size="large"
            fullWidth
            // endIcon={<ArrowForwardRoundedIcon style={{ fontSize: '20px' }} />}
            type="submit"
            variant="contained"
            disabled={!isValidMobile}
          >
            {btnText}
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}

export default CustomPlanForm;
